// 自动加载全局组件
export default function autoRegisterComponents(app) {
  const componentsContext = require.context('./', true, /index.vue$/);

  componentsContext.keys().forEach(fileName => {
    const component = componentsContext(fileName).default;
    app.component(component.name, component);
  });
}
